<template>
  <modal
  name="settings-modal"
  height="auto"
  :pivot-y="0.3"
  :adaptive="true"
  :width="428"
  :clickToClose="false"
  @before-open="beforeOpen"
  @before-close="beforeClose">
    <div class="Settings__container">
      <div class="Settings__title">
        Settings
      </div>
      <form name="settings">
        <div class="Grid-row">
          <div class="form-label">
            Microphone
          </div>
          <v-select
          :on-change="inputChanged"
          class="field-singleselect"
          v-model="devices.selectedInput"
          :options="devices.input">
          </v-select>
        </div>
        <div class="Grid-row">
          <div class="form-label">
            Audio Output
          </div>
          <v-select
          :on-change="outputChanged"
          class="field-singleselect"
          v-model="devices.selectedOutput"
          :options="devices.output">
          </v-select>
        </div>
        <div class="Grid-row">
          <div class="form-label">
            Volume Indicator
          </div>
          <div class="Settings__volume-indicator">
            <div v-for="cell in 10"
                 class="Settings__volume-indicator-cell"
                 :class="{'active': volume >= cell}"></div>
          </div>
        </div>
        <div class="Grid-row">
          <div class="form-actions pull-right">
            <a @click="cancel"
               class="cancel-btn">cancel</a>
            <a @click="submit"
               class="submit-btn">save</a>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'Settings',
    data() {
      return {
        volume: null,
        interval: null,
        audioContext: null
      };
    },
    computed: {
      devices() {
        return this.$store.getters.devices;
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            localStorage.setItem(
              'default-audio-input',
              this.devices.selectedInput.deviceId
            );
            localStorage.setItem(
              'default-audio-output',
              this.devices.selectedOutput.deviceId
            );
          }
          this.$modal.hide('settings-modal');
        });
      },
      cancel() {
        this.$store.dispatch('setDefaultDevices');
        this.$modal.hide('settings-modal');
      },
      inputChanged(v) {
        if (
          v &&
          this.devices.selectedInput.deviceId !== v.deviceId
        ) {
          this.$store.dispatch('startStream', v.deviceId).then(stream => {
            this.initIndicator();
          });
          this.devices.selectedInput = v;
        } else {
          this.devices.selectedInput = this.devices.input[0];
        }
      },
      outputChanged(v) {
        if (this.devices.selectedOutput.deviceId !== v.deviceId) {
          this.$store.dispatch('attachSinkId', v.deviceId);
          this.devices.selectedOutput = v;
        }
      },
      initIndicator() {
        if (this.interval) {
          clearInterval(this.interval);
        }
        const analyser = this.audioContext.createAnalyser();
        const microphone = this.audioContext.createMediaStreamSource(this.$store.getters.localStream);

        analyser.minDecibels = -130;
        analyser.maxDecibels = -30;
        analyser.smoothingTimeConstant = 0.7;
        analyser.fftSize = 256;

        microphone.connect(analyser);

        this.interval = setInterval(() => {
          const array = new Uint8Array(analyser.frequencyBinCount);
          analyser.getByteFrequencyData(array);
          let values = 0;
          const length = array.length;
          for (let i = 0; i < length; i++) {
            values += array[i];
          }

          this.volume = (values / length) / 25.6;
        }, 15);
      },
      beforeOpen() {
        this.$store.commit('getDevices');
        this.initIndicator();
      },
      beforeClose() {
        clearInterval(this.interval);
      }
    },
    created() {
      this.audioContext = window.AudioContext || window.webkitAudioContext;
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// settings.modal.vue?001d7ed9